import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { RichText } from "../common/CellText";

const ContentModal = ({
    headerTitle = "Công việc",
    open,
    handleClose,
    content,
}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={"paper"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="doc-popup"
            fullWidth
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100vw",
                        maxWidth: "100vw", // Set your width here
                        mx: 0,
                    },
                },
            }}
        >
            <DialogTitle
                id="scroll-dialog-title"
                className="text-xl font-bold text-[#23374D] !pt-8"
                sx={{
                    fontWeight: 700,
                }}
            >
                <span className="font-bold">{headerTitle}</span>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                    className="min-h-[250px] mt-4"
                >
                    <RichText
                        text={content}
                        className="font-normal text-xl leading-[36px] text-[#161616]"
                    ></RichText>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button
                    sx={{ fontWeight: 600 }}
                    onClick={handleClose}
                    className="pb-6 text-sm font-semibold leading-5 text-primary"
                >
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ContentModal;
